import React from 'react';

export default function CovidLegend(props) {
    return (
        <div className="covid-guide">
            <h3>COVID-19 Cases</h3>
            <div className="table-container">
                <table className="table">
                    <tbody>
                    <tr>
                        <td className="color-guide-square cases-50"/>
                        <td>1-50</td>
                    </tr>
                    <tr>
                        <td className="color-guide-square cases-500"/>
                        <td> 51-500</td>
                    </tr>
                    <tr>
                        <td className="color-guide-square cases-1000"/>
                        <td>501-1,000</td>
                    </tr>
                    <tr>
                        <td className="color-guide-square cases-5000"/>
                        <td>1,001-5,000</td>
                    </tr>
                    <tr>
                        <td className="color-guide-square cases-5000-plus"/>
                        <td> 5,000+</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
